import './style.css';

export function youtube_overlay(url) {        
    return new Promise((resolve, reject) => {
        let dlg = new Graphite.ModalDialog({
            id:"youtube-overlay",
            width: 840,
            padding: '0'
        })

        let pattern = /https:\/\/www\.youtube\.com\/watch\?v=([a-zA-Z0-9_\-]+)/;
        let matches = url.match(pattern);

        if (matches) {
            let vid = matches[1];
            let embeded_url = 'https://www.youtube.com/embed/' + vid + '?autoplay=1';

            let sb = new Array();

            sb.push('<mx-placeholder>');
            sb.push('<iframe src=""></iframe>');
            sb.push('</mx-placeholder>');

            dlg.html(sb.join(''));
          
            let placeholder = dlg.popup.querySelector('mx-placeholder');
            let iframe = dlg.popup.querySelector('iframe');

            iframe.on('load', evt => {
                placeholder.ready();
            })

            iframe.setAttribute('src', embeded_url);

            resolve(dlg.open());        
            return;
        }

        reject();
    })
}

export function youtube_short_overlay(url) {        
    return new Promise((resolve, reject) => {
        console.log('0000');

        let dlg = new Graphite.ModalDialog({
            id: "youtube-short-overlay",
            width: 380,
            padding: '0'
        })

        let pattern = /^https:\/\/(www\.)?youtube\.com\/shorts\/([a-zA-Z0-9_\-]+)/;
        let matches = url.match(pattern);

        if (matches) {
            let vid = matches[2];
            let embeded_url = 'https://www.youtube.com/embed/' + vid + '?autoplay=1';

            let sb = new Array();

            sb.push('<mx-placeholder>');
            sb.push('<iframe src=""></iframe>');
            sb.push('</mx-placeholder>');

            dlg.html(sb.join(''));
          
            let placeholder = dlg.popup.querySelector('mx-placeholder');
            let iframe = dlg.popup.querySelector('iframe');

            iframe.on('load', evt => {
                placeholder.ready();
            })

            iframe.setAttribute('src', embeded_url);

            resolve(dlg.open());        
            return;
        }

        reject();
    })
}

export function tiktok_overlay(url) {        
    return new Promise((resolve, reject) => {
        let dlg = new Graphite.ModalDialog({
            id:"tiktok-overlay",
            width: 323,
            padding: '0'
        })

        let pattern = /^https:\/\/www\.tiktok\.com\/@(.+)\/video\/(\d+)/;
        let matches = url.match(pattern);

        if (matches) {
            let user = matches[1];
            let vid = matches[2];
            let embeded_url = 'https://www.tiktok.com/embed/v2/' + vid;

            console.log(embeded_url);

            let sb = new Array();

            sb.push('<mx-placeholder>');
            sb.push('<iframe src=""></iframe>');
            sb.push('</mx-placeholder>');

            dlg.html(sb.join(''));
          
            let placeholder = dlg.popup.querySelector('mx-placeholder');
            let iframe = dlg.popup.querySelector('iframe');

            iframe.on('load', evt => {
                placeholder.ready();
            })

            iframe.setAttribute('src', embeded_url);

            resolve(dlg.open());        
            return;
        }

        reject();
    })
}

export async function imgbb_overlay(url) {
    await Graphite.install_plugin('photoswipe');
 
    return new Promise((resolve, reject) => {
        if (url.startsWith('https://ibb.co/')) {

            Graphite.get_imgbb_image_info(url).then(async res => {
                if (res.status == 200) {
                    let { node } = res;

                    Graphite.lightbox([{
                        src: node.url,
                        w: node.width,
                        h: node.height
                    }])

                    resolve();
                    return;
                } else {
                    reject();
                }
            })
        } else {
            reject();
        }
    })
}
